/**
 * 商户在库记录
 */
import React from "react";
import { Row, Col, Button, Input, Modal, Tooltip, Icon } from "antd";
import PageLayout from "../../ui/PageLayout";
import http from "../../../axios/http";
import messager from "../../ui/messager";
import server from "../../../axios/server";
import { global_data } from '../../ui/auth'

class MemberParkDetail extends React.Component {
  columns = [
    {
      title: "车架号",
      dataIndex: "vin",
      width: "20%",
    },
    {
      title: "入场车牌",
      dataIndex: "plateNo",
      width: "20%",
    },
    {
      title: "入场时间",
      dataIndex: "inTime",
      width: "20%",
    },
    {
      title: "操作",
      dataIndex: "id",
      render: (text, record, index) => (
        <div>
          {global_data.authCode.includes("BARRIER_MEMBER_PARK_RELEASE")?
          <Tooltip title="手工离场">
            <Icon
              type="stop"
              theme="filled"
              className="table-operate-icon"
              onClick={this.realeaseInfo.bind(this, record)}
            />
          </Tooltip>
          :""}
        </div>
      ),
    },
  ];

  state = {
    loadData: "",
    queryData: {
      memberCode: "",
      zone: 1,
      keyword: "",
    },
    memberName: "",
  };

  vinSearch = (value) => {
    var queryData = this.state.queryData;
    queryData.keyword = value;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  realeaseInfo = (info, e) => {
    messager.confirm("是否释放此条商城停车记录？", () => {
      http.post({
        url: "/barrier/vehicleParkInfo/releaseParkInfo",
        data: { id: info.id },
        success: (res) => {
          http.post({
            url:
              server.mallServerUrl + "/externalApi/barrier/updateParkInfoCache",
            data: { id: info.id },
            success: (res) => {
              console.log("mallapi停车缓存刷新成功");
            },
          });
          let queryData = this.state.queryData;
          this.state.loadData(queryData);
          messager.notify("处理成功！");
        },
      });
    });
  };

  exportExcel = () => {
    var { memberCode, memberName, zone } = this.props;
    http.download({
      url: "/barrier/memberVehiclePark/downloadExcel",
      data: { memberCode, zone },
      fileName: `${memberName}(${zone})停车明细.xlsx`,
    });
  };

  componentWillReceiveProps(nextProp) {
    console.log(nextProp);
    var { visible, memberCode, zone } = nextProp;
    if (visible) {
      let queryData = this.state.queryData;
      queryData.memberCode = memberCode;
      queryData.zone = zone;
      queryData.keyword = "";
      this.setState({ queryData });
      if (this.state.loadData) this.state.loadData(queryData);
    }
  }

  render() {
    const { visible, memberName, memberCode, onCancel, zone } = this.props;
    const { keyword } = this.state.queryData;
    return (
      <Modal
        width={1000}
        height={800}
        visible={visible}
        title={memberName + "停车明细"}
        onCancel={onCancel}
        footer={null}
      >
        <div style={{ width: "100%", height: "500px" }}>
          <PageLayout
            condition={
              <Row>
                <Col span={6}>
                  <Input.Search
                    key={this.state.queryData.keyword}
                    defaultValue={this.state.queryData.keyword}
                    placeholder="车架号或车牌号"
                    onSearch={this.vinSearch}
                    enterButton
                  />
                </Col>
                <Col span={1}></Col>
                <Col span={3}>
                  <Button onClick={this.exportExcel.bind(this)}>
                    导出Excel
                  </Button>
                </Col>
              </Row>
            }
            rowKey="id"
            url="/barrier/vehicleParkInfo/queryByMember"
            columns={this.columns}
            initParams={{ memberCode, zone, keyword }}
            loadData={(func) => {
              console.log("detial props", this.props);
              this.setState({
                queryData: { memberCode, zone, keyword },
                memberName,
                loadData: func,
              });
            }}
          />
        </div>
      </Modal>
    );
  }
}

export default MemberParkDetail;
